// States data - imported from JSON
export interface State {
  id: number;
  name: string;
  code: string;
}

// Import the states JSON data
export const STATES_DATA: Record<string, State[]> = require('./states.json');

export function getStatesByCountryId(countryId: number): State[] {
  return STATES_DATA[String(countryId)] || [];
}

export function getStateById(countryId: number, stateId: number): State | undefined {
  const states = getStatesByCountryId(countryId);
  return states.find(state => state.id === stateId);
}

export function getStateByName(countryId: number, name: string): State | undefined {
  const states = getStatesByCountryId(countryId);
  return states.find(state => state.name.toLowerCase() === name.toLowerCase());
}

export function getStateByCode(countryId: number, stateCode: string): State | undefined {
  const states = getStatesByCountryId(countryId);
  return states.find(state => state.code.toUpperCase() === stateCode.toUpperCase());
}
